import {addReducerParametersToError} from "../middleware/middleware-error-handler";
import {EXTRA_SCREEN, GAME_SCREEN, LOGOS_SCREEN, PLAY_SCREEN} from "./duck-screen";

export const PUSH = 'ROUTER/PUSH';
export const REPLACE = 'ROUTER/REPLACE';
export const GO_BACK = 'ROUTER/GO_BACK';
export const LOCATION_CHANGE = 'ROUTER/LOCATION_CHANGE';

/* Akcje głównie przechwytywane są w middleware router */

/**
 * Zmienia strone (pushuje do histori)
 * @param {string} href - ekran.
 */
export function push(href) {
	return {
		type: PUSH,
		payload: {
			href
		},
	}
}

/**
 * Podmienia strone (zamienia w historii)
 * @param {string} href - ekran.
 */
export function replace(href) {
	return {
		type: REPLACE,
		payload: {
			href
		},
	}
}

/**
 * Cofa do poprzedniej strone
 */
export function goBack() {
	return {
		type: GO_BACK,
	}
}

/**
 *
 * Wywołuje się po zmianie adresu url
 * ma ustawiony listener w src/helpers/history-listener.js
 * @param pathname - ścieżka
 */
export function locationChange (pathname) {
	return {
		type: LOCATION_CHANGE,
		payload: {
			pathname,
		}
	}
}

export function navigateToLevelList(currentScreen){
	return dispatch => {
		switch (currentScreen){
			case GAME_SCREEN:{
				dispatch(goBack());
				break;
			}
			case PLAY_SCREEN: {
				dispatch(push(LOGOS_SCREEN));
				break;
			}
			case EXTRA_SCREEN: {
				dispatch(push(PLAY_SCREEN));
				dispatch(push(LOGOS_SCREEN));
				break;
			}
			default:{
				break;
			}
		}
	}
}


const defaultState = {
	pathname: '/',
};
/**
 * Używany w store/index.js w celu określenia aktualnego url //TODO sprawdzić czy potrzebne
 * @param state - aktualny stan routerReducer
 * @param action - aktualnie wykonywana akcja
 */
export default function (state = defaultState, action){
	try{
		switch (action.type) {
			case LOCATION_CHANGE:
				return {
					...state,
					...action.payload,
				};
			default:
				return state;
		}
	} catch(error){
		addReducerParametersToError(error, "error_router_reducer", action, state);
		throw error
	}
};